import { el, unmount, mount, setAttr } from 'redom';

import serverInterface from 'server-interface';

import { stringToSVG } from 'utilities';
import {
  displayElementAroundAnchor
} from 'utilities/element-position';

import Tooltip from 'generics/components/tooltip/native';

import bookmarkIconString from 'assets/images/bookmark-icon.svg?raw';

import BookmarksViewer from './viewer';

import './index.scss';

const bookmarkIcon = stringToSVG(bookmarkIconString);

let viewer = null;

class BookmarksButton {

  constructor(configuration) {

    this.conversation = configuration.conversation;
    this.bookmarksConfiguration = configuration.bookmarks;

    this.el = el('button.sent-message-bookmarks-button', {
      onclick: this.handleClick.bind(this)
    }, [
      bookmarkIcon.cloneNode(true)
    ]);
    this.tooltip = new Tooltip({
      target: this.el,
      content: 'Bookmarks',
      placement: 'top',
      offset: 10,
      placeOnCenter: true
    });

  }

  handleBookmarkSelect(bookmark) {
    // this.internetPhone.setContent(bookmark.content);
    this.bookmarksConfiguration.onSelect(bookmark);
    serverInterface.startup.sentMessageBookmarks.markSentMessageBookmarkAsUsed(bookmark._id);
  }

  handleBookmarkDelete(bookmark) {
    this.positionViewer();
    this.bookmarksConfiguration.onDelete(bookmark);
    if (this.bookmarksConfiguration.bookmarks.length === 0) {
      this.handleViewerClose();
    }
  }

  handleViewerClose() {

    unmount(document.getElementById('root-level-dynamic-elements-container'), viewer);

    viewer = null;

  }

  positionViewer() {

    const element = viewer.el;
    const anchorElement = this.el;
    const viewportElement = void 0;
    const verticalOffset = 5;
    const horizontalOffset = 15;
    const startSide = 'top';
    const placeOnCenter = false;
    const positionableSides = ['top'];
    // console.log(viewer.el.style.height);
    // viewer.el.style.height = 'auto';
    // viewer.el.style.height = `${viewer.el.getBoundingClientRect().height}px`;
    setAttr(viewer.el, { style: {} });
    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

  }

  displayViewer() {

    viewer = new BookmarksViewer({
      bookmarks: this.bookmarksConfiguration.bookmarks,
      onSelect: this.handleBookmarkSelect.bind(this),
      onDelete: this.handleBookmarkDelete.bind(this),
      onClose: this.handleViewerClose.bind(this)
    });

    mount(document.getElementById('root-level-dynamic-elements-container'), viewer);

    this.positionViewer();

  }

  handleClick(event) {

    event.stopPropagation();
    event.preventDefault();

    this.displayViewer();

  }

  update(configuration) {

  }

  onunmount() {

    if (viewer === null) {
      return;
    }

    if (this.bookmarksConfiguration.bookmarks.length > 0) {
      return;
    }

    this.handleViewerClose();

  }

}

export default BookmarksButton;